import type { IPublicReceiptRepository } from '../repositories/IPublicReceiptRepository.js';

interface Deps { publicReceiptRepository: IPublicReceiptRepository; }

export function createGetPublicReceiptUseCase({ publicReceiptRepository }: Deps) {
  return (code: string) => publicReceiptRepository.getByCode(code);
}
